var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('form',_vm._l((_vm.categories),function(child){return _c('category-tree',{key:child.name,attrs:{"category":child}})}),1)])])}
var staticRenderFns = []

export { render, staticRenderFns }